import React from "react";
import "./ComingSoon.css";

export default function ComingSoon() {
  return (
    <section className="coming-soon-page">
      <div className="coming-soon-pattern"></div>

      <div className="coming-soon-content">
        <div className="coming-soon-icon">
          <i className="bi bi-tools"></i>
        </div>

        <p className="coming-soon-label">MISBAHI WELFARE MISSION</p>

        <h1>
          This Page is <span>Coming Soon</span>
        </h1>

        <p className="coming-soon-text">
          We are working to bring you something meaningful and beautiful.
          This section is currently under development and will be available
          soon, In Sha Allah.
        </p>

        <div className="coming-soon-divider">
          <span>✦</span>
        </div>

        <p className="arabic-text">
          إِنْ شَاءَ اللّٰهُ
        </p>

        <p className="coming-soon-small">
          Thank you for your patience and support.
        </p>

        <button
          className="coming-soon-btn"
          onClick={() => window.history.back()}
        >
          <i className="bi bi-arrow-left"></i>
          Go Back
        </button>
      </div>
    </section>
  );
}